import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CTA_FORM_ID = '51chigua-home-subscribe';
const FORM_SUBMIT_URL = 'http://dingzhishi.cn/';

export default function CTASection() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    const formData = new FormData(e.currentTarget);
    const honeypot = formData.get('mobile_alt') as string;
    if (honeypot && honeypot.trim()) {
      setSubmitStatus('success');
      setEmail('');
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append('email', email.trim());
      const res = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse error */ }
      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setSubmitStatus('error');
        setFormError(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setSubmitStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {t('home_cta_title')}
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-[480px] mx-auto">
            {t('home_cta_subtitle')}
          </p>

          {submitStatus === 'success' ? (
            <p className="mt-6 text-sm text-primary-600 font-medium">订阅成功！每天新鲜瓜料准时送达~</p>
          ) : (
            <form
              id={CTA_FORM_ID}
             
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-7 max-w-[440px] mx-auto"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                className="flex-1 w-full px-5 py-3 rounded-full border border-background-300 bg-background-50 text-foreground-950 text-sm placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                required
              />
              <input
                type="text"
                name="mobile_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-anti-spam-field"
              />
              <button
                type="submit"
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                {t('home_cta_button')}
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </button>
            </form>
          )}
          {submitStatus === 'error' && (
            <p className="text-accent-500 text-xs mt-2">{formError}</p>
          )}
        </div>

        <div className="mt-12 relative w-full h-[140px] md:h-[180px] overflow-hidden rounded-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Collage%20of%20entertainment%20news%20elements%2C%20silhouettes%20of%20people%20reading%20news%20on%20phones%2C%20warm%20peach%20and%20cream%20background%2C%20modern%20minimalist%20style%2C%20abstract%20shapes%2C%20soft%20gradient%2C%20clean%20composition&width=1800&height=400&seq=cta-banner-01&orientation=landscape"
            alt="每日吃瓜爆料订阅"
            title="每日吃瓜爆料订阅"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50/60 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}